export var WeekdayPosition;
(function (WeekdayPosition) {
    WeekdayPosition["First"] = "FIRST";
    WeekdayPosition["Second"] = "SECOND";
    WeekdayPosition["Third"] = "THIRD";
    WeekdayPosition["Fourth"] = "FOURTH";
    WeekdayPosition["Fifth"] = "FIFTH";
    WeekdayPosition["Last"] = "LAST";
})(WeekdayPosition || (WeekdayPosition = {}));
